
const data = {
  menuItems: [
    {
      label: 'Home',
      path: '#home',
      offset: '80',
    },
    {
      label: 'Services',
      path: '#features',
      offset: '80',
    },
    {
      label: 'About Us',
      path: '#aboutus',
      offset: '80',
    },
    {
      label: 'Contact Us',
      path: '#contactus',
      offset: '80',
    },
  ],
  aboutus: [
    {
      id: 1,
      title: 'We have a combined 20+ years experience in big data, machine learning and software engineering in the hedge fund and banking industry',
      icon: 'flaticon-next',
    },
    {
      id: 2,
      title: 'We are industry agnostic and apply pragmatic, simple and cost effective solutions to business and technology problems ',
      icon: 'flaticon-next',
    },
    {
      id: 3,
      title: "We understand that data engineering and data modeling require deep domain understanding. We therefore work closely with our clients' domain experts ",
      icon: 'flaticon-next',
    },
    {
      id: 4,
      title: "Applying our software engineering and machine learning skills to solving real business problems is our lifelong passion ",
      icon: 'flaticon-next',
    },
  ],
  features: [
    {
      id: 1,
      icon: 'flaticon-atom',
      title: 'Data and Predictive Analytics',
      description:
        'Use the power of data and machine learning to inform strategic decisions. We implement the entire data pipeline - data warehouses, feature extraction and engineering, machine learning model selection and analytics presentation.',
    },
    {
      id: 3,
      icon: 'flaticon-conversation',
      title: 'Conversational AI (Chatbots)',
      description:
        'Engage customers 24/7. We build and train multi-channel AI chatbots that integrate with other platforms (Messenger, Slack, Salesforce etc). We analyze the virtual agent conversations to augment your data analytics.',
    },
    {
      id: 3,
      icon: 'flaticon-bitcoin',
      title: 'Cloud Services and CRM Implementation',
      description:
        'Transition to the cloud. We  offer cloud migration services and custom application development (AWS and GCP). We customize and configure CRM systems for the specific needs of our clients (Salesforce, Dynamics). '
    },
  ],
  // qualityFeature: [
  //   {
  //     id: 1,
  //     icon: 'flaticon-flask',
  //     title: 'Search Optimization',
  //     description:
  //       'By using Search Engine Optimization, You will get more Clients.',
  //   },
  //   {
  //     id: 2,
  //     icon: 'flaticon-pencil-case',
  //     title: 'Wireframing Task',
  //     description:
  //       'We respect our customer opinions and deals with them with perfect wireframing.',
  //   },
  //   {
  //     id: 3,
  //     icon: 'flaticon-ruler',
  //     title: 'Ui/Ux Design',
  //     description:
  //       'We provide the best UI/UX Design by following the latest trends of the market .',
  //   },
  //   {
  //     id: 4,
  //     icon: 'flaticon-briefing',
  //     title: 'Content Writting',
  //     description:
  //       'Proper Content Management is important to find out the real clients for your agencies .',
  //   },
  // ],
  // blog: [
  //   {
  //     id: 1,
  //     title: 'Real home corporation',
  //     thumbnail_url: BlogImage1,
  //     date: 'November 02, 2018',
  //     postLink: '#1',
  //   },
  //   {
  //     id: 2,
  //     title: 'Sheltech developer ltd.',
  //     thumbnail_url: BlogImage2,
  //     date: 'November 12, 2018',
  //     postLink: '#2',
  //   },
  //   {
  //     id: 3,
  //     title: 'Alt architecture co.',
  //     thumbnail_url: BlogImage3,
  //     date: 'December 09, 2018',
  //     postLink: '#3',
  //   },
  // ],
  // teamMember: [
  //   {
  //     id: 1,
  //     name: 'Jessica Fanddy',
  //     thumbnail_url: Member1,
  //     designation: 'Co Founder',
  //     social_links: [
  //       'flaticon-facebook-logo',
  //       'flaticon-twitter-logo-silhouette',
  //       'flaticon-instagram',
  //       'flaticon-dribble-logo',
  //     ],
  //   },
  //   {
  //     id: 2,
  //     name: 'Devid Justingul',
  //     thumbnail_url: Member2,
  //     designation: 'Senior Ui/UX Designer',
  //     social_links: [
  //       'flaticon-twitter-logo-silhouette',
  //       'flaticon-instagram',
  //       'flaticon-facebook-logo',
  //       'flaticon-dribble-logo',
  //     ],
  //   },
  //   {
  //     id: 3,
  //     name: 'Handdy Albuzz',
  //     thumbnail_url: Member3,
  //     designation: 'Article Writter',
  //     social_links: [
  //       'flaticon-dribble-logo',
  //       'flaticon-twitter-logo-silhouette',
  //       'flaticon-instagram',
  //       'flaticon-facebook-logo',
  //     ],
  //   },
  // ],
  // testimonial: [
  //   {
  //     id: 1,
  //     name: 'Denny Albuz',
  //     designation: 'CEO of Denish Co.',
  //     comment:
  //       'Best working experience  with this amazing team & in future, we want to work together',
  //     avatar_url: Denny,
  //   },
  //   {
  //     id: 2,
  //     name: 'Roman Ul Oman',
  //     designation: 'Co-founder of QatarDiaries',
  //     comment:
  //       'Impressed with master class support of the team and really look forward for the future.',
  //     avatar_url: Menny,
  //   },
  //   {
  //     id: 3,
  //     name: 'Caroleane Mina',
  //     designation: 'Director of Beauty-queen',
  //     comment:
  //       'I have bought more than 10 themes on ThemeForest, and this is the first one I review. Wow! Amazing React Theme',
  //     avatar_url: Denny,
  //   },
  //   {
  //     id: 4,
  //     name: 'Roman Ul Oman',
  //     designation: 'Co-founder of QatarDiaries',
  //     comment:
  //       'Impressed with master class support of the team and really look forward for the future.',
  //     avatar_url: Menny,
  //   },
  // ],
  faq: [
    {
      id: 1,
      expend: true,
      title: 'How to contact with Customer Service?',
      description:
        'Our Customer Experience Team is available 7 days a week and we offer 2 ways to get in contact.Email and Chat . We try to reply quickly, so you need not to wait too long for a response!. ',
    },
    {
      id: 2,
      title: 'App installation failed, how to update system information?',
      description:
        'Please read the documentation carefully . We also have some online  video tutorials regarding this issue . If the problem remains, Please Open a ticket in the support forum . ',
    },
    {
      id: 3,
      title: 'Website reponse taking time, how to improve?',
      description:
        'At first, Please check your internet connection . We also have some online  video tutorials regarding this issue . If the problem remains, Please Open a ticket in the support forum .',
    },
    {
      id: 4,
      title: 'New update fixed all bug and issues?',
      description:
        'We are giving the update of this theme continuously . You will receive an email Notification when we push an update. Always try to be updated with us .',
    },
  ],
  menuWidget: [
    {
      id: 1,
      title: '',
      menuItems: [
        {
          id: 1,
          url: '#home',
          text: 'Home',
        },
        {
          id: 2,
          url: '#aboutus',
          text: 'About Us',
        },
        {
          id: 3,
          url: '#features',
          text: 'Our Services',
        },
        {
          id: 4,
          url: '#contactus',
          text: 'Contact Us',
        },
      ],
    },
  ],
  social_profile: [
    {
      id: 1,
      icon: 'flaticon-facebook-logo',
      link: '#1',
    },
    {
      id: 2,
      icon: 'flaticon-twitter-logo-silhouette',
      link: '#2',
    },
    {
      id: 3,
      icon: 'flaticon-instagram',
      link: '#3',
    },
    {
      id: 4,
      icon: 'flaticon-tumblr-logo',
      link: '#4',
    },
    {
      id: 5,
      icon: 'flaticon-dribble-logo',
      link: '#5',
    },
  ],
};
export default data;
